<template>
    <div>
        <my-header></my-header>
        <div id="index">
            <div class="first">
                <el-row>
                    <el-col :span="9">
                        <img class="img" :src="src" fit="fill"></img>
                        <div class="text">
                            <div>统一代码：{{ssuppliers.socialCreditCode}}</div>
                            <div>{{ssuppliers.companyName}}</div>
                        </div>
                    </el-col>
                    <el-col :span="3">
                        <div class="num">{{$root.moneyFormat(yqhtAmount)}}</div>
                        <div class="type">已签合同总金额</div>
                    </el-col>
                    <el-col :span="3">
                        <div class="num">{{$root.moneyFormat(ljfkAmount)}}</div>
                        <div class="type">累计收款金额</div>
                    </el-col>
                    <el-col :span="3">
                        <div class="num">{{$root.moneyFormat(yfwfAmount)}}</div>
                        <div class="type">应收未收金额</div>
                    </el-col>
                    <el-col :span="2" style="cursor: pointer;" @click.native="showBidTable(1)">
                        <div class="num">{{winBidCount}}</div>
                        <div class="type">中标数</div>
                    </el-col>
                    <el-col :span="2" style="cursor: pointer;" @click.native="showContractTable(8)">
                        <div class="num">{{yqCount}}</div>
                        <div class="type">已签合同</div>
                    </el-col>
                    <el-col :span="2" style="cursor: pointer;" @click.native="showApplyTable(10)">
                        <div class="num">{{lypgScore}}</div>
                        <div class="type">履约评估得分</div>
                    </el-col>
                </el-row>
            </div>
            <div class="second">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-card shadow="always" :body-style="cardStyle" class="card_box" :class="{'active': tableType == 0}">
                            <div @click="showTodo">
                                <div class="title">待办事项</div>
                                <div class="num">{{itemCountMap['dealAll'] || '0'}}</div>
                                <i class="iconfont icondaibantixing1 icon"></i>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card shadow="always" :body-style="cardStyle" class="card_box" :class="{'active': tableType == 1}">
                            <div class="title">投标</div>
                            <div class="num">{{itemCountMap['all'] || '0'}}</div>
                            <i class="iconfont iconcooperation icon"></i>
                            <div class="hover_box">
                                <ul class="ul_01">
                                    <li @click="showBidTable(2)">
                                        <span class="fl">投标查询</span>
                                        <!-- <span>({{itemCountMap['all'] || '0'}})</span> -->
                                    </li>
                                    <li @click="showBidTable(3)">
                                        <span class="fl">邀请函</span>
                                        <span>({{itemCountMap['yqh'] || '0'}})</span>
                                    </li>
                                    <li @click="showBidTable(4)">
                                        <span class="fl">回标</span>
                                        <span>({{itemCountMap['hb'] || '0'}})</span>
                                    </li>
                                    <li @click="showBidTable(5)">
                                        <span class="fl">商务谈判</span>
                                        <span>({{itemCountMap['swtp'] || '0'}})</span>
                                    </li>
                                    <li @click="showBidTable(6)">
                                        <span class="fl">中标</span>
                                        <span>({{itemCountMap['zb'] || '0'}})</span>
                                    </li>
                                </ul>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card shadow="always" :body-style="cardStyle" class="card_box" :class="{'active': tableType == 2}">
                            <div class="title">合同履约</div>
                            <div class="num">{{itemCountMap['htlyAll'] || '0'}}</div>
                            <i class="iconfont iconhetonglvyue icon"></i>
                            <div class="hover_box">
                                <ul class="ul_02">
                                    <li @click="showContractTable(8)">合同信息查询</li>
                                    <li @click="showContractTable(9)">合同验收({{itemCountMap['yssq'] || '0'}})</li>
                                    <!-- <li @click="showContractTable(9)">验收申请查询({{itemCountMap['yssq'] || '0'}})</li> -->
                                    <br>
                                    <li @click="showContractTable(10)">物料订单结算({{itemCountMap['htdd'] || '0'}})</li>
                                    <!-- <li @click="showContractTable(10)">合同订单查询({{itemCountMap['htdd'] || '0'}})</li> -->
                                    <li @click="showContractTable(11)">派工单结算({{itemCountMap['jssq'] || '0'}})</li>
                                    <!-- <li @click="showContractTable(11)">结算申请查询({{itemCountMap['jssq'] || '0'}})</li> -->
                                </ul>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card shadow="always" :body-style="cardStyle" class="card_box" :class="{'active': tableType == 3}">
                            <div class="title">常用操作</div>
                            <i class="iconfont iconhetonglvyue1 icon"></i>
                            <div class="hover_box">
                                <ul class="ul_03">
                                    <li @click="goRegister">
                                        企业信息维护
                                    </li>
                                    <li @click="bidNotice">
                                        招标公告
                                    </li>
                                 <!--   <li @click="showApplyTable(15)">
                                        投诉举报
                                    </li>-->
                                </ul>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
            <div style="margin-top: 8px;">
                <bid-todo-table @showWinBid="showWinBidCallback" v-show="tableType == 0" ref="bidTodoTable"></bid-todo-table>
                <supplier-todo-table v-show="tableType == 0" ref="supplierTodoTable"></supplier-todo-table>

                <bidTable @showWinBid="showWinBidCallback" v-show="tableType == 1" :innerTableType="innerTableType" ref="bidTable"></bidTable>
                <contractTable v-show="tableType == 2" :innerTableType="innerTableType" ref="contractTable"></contractTable>
                <applyTable v-show="tableType == 3" :innerTableType="innerTableType" ref="applyTable"></applyTable>
            </div>
        </div>
        <div class="winBid" v-if="winBidShow">
            <div class="winBid-top">
                <div :style="{backgroundImage:`url(${orgBackground})`}" style="width: 100%;height: 100%">
                <img style="position:absolute; left: 16px; top: 88px;" src="../../assets/images/inviteList/line_vertical.png"/>
                <img style="position:absolute; right: 16px; top: 88px;" src="../../assets/images/inviteList/line_vertical.png"/>
                <div class="winBid-title">
                    中标通知书
                </div>
                <div style="float: right; position: absolute; top: 0; right: 40px;">
                    <img style="height: 45px;" src="../../assets/images/login/logo.png" alt="">
                </div>
                <i @click="closeWinBid" class="el-icon-close" style="font-size: 30px; position: absolute; right: -25px; top: -20px;color:#999;cursor: pointer;"></i>

                <p class="winBid-company">
                {{companyName}}：
                </p>
                <p style="text-indent: 30px;" class="winBid-content">
                    {{smyDeals.dealTitle}}
                </p>
                <p style="margin-top: 38px;margin-bottom:40px;">
                    特此通知
                </p>
                <div class="clearfix">
                    <div style="float: left;line-height: 35px;">
                        <p>
                            <!-- 甲方联系人：{{extWFlowForm.handleUserName}} -->
                            合同对接人：{{ extWFlowForm.promoterUserName }}
                        </p>
                        <p>
                            联系电话：{{ extWFlowForm.promoterUserPhone }}
                        </p>
                    </div>
                    <div style="float: left;line-height: 35px;margin-left: 96px;">
                        <p>
                            <!-- 乙方联系人：{{bid.supContractName}} -->
                            招标对接人：{{ extWFlowForm.handleUserName }}
                        </p>
                        <p>
                            联系电话：{{ extWFlowForm.handleUserPhone }}
                        </p>
                    </div>
                </div>

                <div style="text-align: right;">
                    <p>
                        {{ bid.extWFlowForm.projectName }}
                        <!-- 合商科技有限公司 -->
                    </p>
                    <p>
                        {{$root.getMyDate(smyDeals.createDate,2)}}
                    </p>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    import MyHeader from '../common/Header.vue'
    import MyFooter from '../common/Footer.vue'
    import bidTable from '../../components/bidTable.vue'
    import contractTable from '../../components/contractTable.vue'
    import applyTable from '../../components/applyTable.vue'
    import bidTodoTable from '../../components/bidTodoTable.vue'
    import supplierTodoTable from '../../components/supplierTodoTable.vue'
    import watermark from "../../util/waterMark.js";
    export default {
        name: 'win-list',
        data(){
            return {
                companyName: window.sessionStorage.getItem('companyName'),

                form: {
                    categoryId: '',
                    msgTitle: ''
                },
                /* pager:{
                    total: 0,
                    pageNum: 1,
                    pageSize: 8
                }, */
                types:[],
                winListData:[],//中标公告列表
                src: '',
                cardStyle:{
                    padding: '30px',
                    position:"relative",
                    height:"45px",
                    cursor: 'pointer',
                },
                tableType:0,
                innerTableType:1,

                ssuppliers: [],
                logo:{},
                itemCountMap: {},


                yqhtAmount: 0,//已签合同总金额
                ljfkAmount: 0,//累计付款金额
                yfwfAmount: 0,//应付未付金额

                winBidCount: 0,//中标数
                yqCount: 0,//已签合同
                lypgScore: 0,//履约评估得分
                bid:{},
                extWFlowForm: {},
                smyDeals:{},

                winBidShow: false,
                orgBackground: "", // 水印
            }
        },
        components: {
            MyHeader, MyFooter,bidTable,contractTable,applyTable,bidTodoTable,supplierTodoTable, watermark
        },
        created(){
            this.$root.inLoginPage = false
            this.getListCount();
        },
        mounted() {
            // localStorage.setItem("loginUserName", "合商科技有限公司");
            // localStorage.setItem("loginUserPhone", "供应商管理部");
            // this.orgBackground = watermark.addWaterMark();
        },
        methods:{
            showTodo(){
                this.tableType = 0;
            },
            showWinBidCallback(obj) {
                let that = this;
                this.$root.postHttp('/v1/outerformflowHS/getWinBid', obj, (res) => {
                    that.bid = res.data.data;
                    localStorage.setItem("loginUserName", that.bid.extWFlowForm.projectName);
                    that.bid.extWFlowForm.projectName == '合商科技有限公司' ? localStorage.setItem("loginUserPhone", "供应商管理部") : localStorage.setItem("loginUserPhone", "");
                    this.orgBackground = watermark.addWaterMark();
                    that.extWFlowForm = res.data.data.extWFlowForm;
                    that.smyDeals = res.data.data.smyDeals;
                    this.winBidShow = true;
                });
            },
            closeWinBid(){
                this.winBidShow = false;
            },
            showBidTable(innerTableType){
                this.tableType = 1;
                this.$refs.bidTable.changeType(innerTableType)
            },
            showContractTable(innerTableType){
                this.tableType = 2;
                this.$refs.contractTable.changeType(innerTableType)
                console.log(this.$refs)
            },
            showApplyTable(innerTableType){
                this.tableType = 3;
                this.$refs.applyTable.changeType(innerTableType)
                console.log(this.$refs)
            },
            handleCurrentChange (page) {

            },
            searchMethod(){//搜索列表

            },
            goRegister(){
                this.$router.push("/register?supplierId=" + sessionStorage.getItem("loginId"))
            },
            bidNotice(){
                this.$router.push("/invite-list")
            },
            getListCount(){
                // POST /v1/sSuppliers/getSupplierInfoItemCount
                let that = this;
                that.$root.postHttp('/v1/outerformflowHS/getMyInfo', {}, function(res) {
                    that.ssuppliers = res.data.data.ssuppliers;
                    if (res.data.data.logo && res.data.data.logo.size > 0){
                        that.logo = res.data.data.logo[0];
                    }
                    let dealBidNumVOS = res.data.data.dealBidNumVOS || [];
                    let itemCountMap = {};
                    dealBidNumVOS.forEach(item => {
                        if(item.wflowFormStatus){
                            itemCountMap[item.wflowFormStatus] = item.num;
                        }
                    });

                    that.itemCountMap = itemCountMap;

                    that.yqhtAmount = res.data.data.yqhtAmount,//已签合同总金额
                    that.ljfkAmount = res.data.data.ljfkAmount;//累计付款金额
                    that.yfwfAmount = res.data.data.yfwfAmount;//应付未付金额
                    that.winBidCount = res.data.data.winBidCount;//中标数
                    that.yqCount = res.data.data.yqCount;//已签合同
                    that.lypgScore = res.data.data.lypgScore;//履约评估得分
                    if(res.data.data.logo.length>0){
                        that.src = that.$root.baseUrl+'/v1/public/download/download_direct?attachmentPath='+res.data.data.logo[0].attachPath+'&attachmentName='+encodeURIComponent(res.data.data.logo[0].attachName);
                        console.log(that.src)
                    }
                });
            },
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../assets/_var.scss';
    #index{
        // width: 1200px;
        padding: 0 60px;
        margin: 0 auto;
        padding-top: 70px;
        .first{
            .img{
                width: 64px;
                height: 64px;
                float: left;
            }
            .text{
                vertical-align: top;
                font-size: 16px;
                line-height: 33px;
                color: #333333;
                text-align: left;
                margin-left: 25px;
                float: left;
            }
            .num{
                color: #003570;
                font-size: 28px;
                margin-bottom: 5px;
            }
            .type{
                color: #333333;
                font-size: 13px;
            }
        }
        .second{
            margin-top: 10px;
            .title{
                text-align: left;
                font-size: 15px;
            }
            .num{
                font-size: 30px;
                color: #91002C;
            }
            .num:nth-child(2),.num:nth-child(3){
                color: #003570;
            }

            .card_box {
                position: relative;
                .icon {
                    position: absolute;
                    font-size: 35px;
                    right: 10px;
                    bottom: 10px;
                    color: #e6e6e6;
                }
            }

            .card_box.active /deep/{
                .el-card__body {
                    border-top:1px solid #003570;
                }
            }

            .card_box:hover .hover_box{
                opacity: 1;
            }
            .hover_box{
                position: absolute;
                top:0;
                left: 0;
                height: 100%;
                width: 100%;
                background-color: rgba(0,53,112,0.9);
                color: #fff;
                // padding-top: 10px;
                transition: all 0.5s;
                opacity: 0;
                box-sizing: border-box;
                padding-left: 25px;
                font-size: 13px;
                .ul_01 li{
                    float: left;
                    width: 50%;
                    line-height: 35px;
                    text-align: left;
                    cursor: pointer;
                    .fl{
                        float: left;
                        width: 80px;
                        box-sizing: border-box;

                    }
                }
                .ul_02 li{
                    cursor: pointer;
                    line-height: 50px;
                    padding: 0 30px 0 0;
                    display: inline;
                }
                .ul_03 li{
                    cursor: pointer;
                    line-height: 50px;
                    padding: 0 30px 0 0;
                    display: block;
                }
            }
        }
    }

    .winBid {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background: rgba($color: #000000, $alpha: 0.3);
        z-index: 999;
    }

    .winBid-top {
      color: #333333;
      position: relative;

      .winBid-title {
        text-align: center;
        margin: 0 auto;
        padding-top: 53px;
        margin-bottom: 30px;
        width: 160px;
        height: 42px;
        font-size: 32px;
        text-align: center;
        line-height: 42px;
      }

      .winBid-company {
        font-weight: bold;
        line-height: 21px;
        font-size: 16px;
      }

      .winBid-content {
          margin-top: 20px;
      }
      padding: 0 80px;
      box-sizing: border-box;
      width: 864px;
      height: 550px;
      margin: auto;
      margin-top: 56px;
      font-size: 15px;
      line-height: 30px;
        background: linear-gradient(180deg,#fafafa -45%, #e9e9e9);
        box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.29);
      img {
        margin-top: 50px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/pages/gateway/index.vue